import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden bg-background-50 px-4 text-center">
      <span className="pointer-events-none absolute select-none font-heading text-[10rem] font-bold leading-none text-background-200 md:text-[16rem]">
        404
      </span>
      <div className="relative z-10 flex flex-col items-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-700">
          <i className="ri-film-line text-3xl" />
        </span>
        <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          这个页面不存在
        </h1>
        <p className="mt-3 max-w-md text-sm leading-7 text-foreground-500">
          你访问的页面可能已被移除或链接不正确。回到首页，继续浏览《我妻子的一切》的剧情、角色与资讯内容吧。
        </p>
        <p className="mt-2 text-xs text-foreground-400">当前路径：{location.pathname}</p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-700 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-800"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
          <Link
            to="/search"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            <i className="ri-search-line" />
            去搜索内容
          </Link>
        </div>
      </div>
    </div>
  );
}